import { api } from 'utils';

interface UserFeedbackRequest {
  id: string;
  transaction: string;
  thumbsUp: boolean;
  message?: string;
  browser: string;
  operatingSystem: string;
}

export default class FeedbackService {
  /**
   * api request adapter object
   */
  private adapter: api.Adapter;
  /**
   * Static constant of search endpoint
   */
  static searchUri = '/v1/feedback';

  constructor(baseURL: string) {
    this.adapter = new api.Adapter({
      baseURL,
      responseType: 'json',
      headers: {
        timeout: 60 * 10 * 1000,
        'content-type': 'application/json',
        accept: 'application/json'
      }
    });
    // This binding maintains the value of this inside these methods during future calls.
    // this.getAddressDetails = this.getAddressDetails.bind(this);
  }

  /**
   * Submit user feedback
   * @param thumbsUp Did user give thumbsUp or not
   * @param message Message from the user
   * @param transactionID unique ID for this users transaction
   */
  async sendFeedback(thumbsUp: boolean, message: string, transactionID: string) {
    const browser = this.getUserBrowser();
    const os = this.getUserOS();

    const payload: UserFeedbackRequest = {
      id: transactionID,
      transaction: 'border-permits',
      thumbsUp: thumbsUp,
      message: message,
      browser: browser,
      operatingSystem: os
    };

    await this.adapter.postValue<UserFeedbackRequest>(FeedbackService.searchUri, payload);
  }

  private getUserBrowser() {
    const userAgent = window.navigator.userAgent;

    // CriOS = Chrome on iOS (for some reason has strange user agent)
    if (userAgent.indexOf('Edg') > -1) return 'Edge';
    else if (userAgent.indexOf('SamsungBrowser') > -1) return 'SamsungBrowser';
    else if (userAgent.indexOf('Chrome') > -1) return 'Chrome';
    else if (userAgent.indexOf('CriOS') > -1) return 'Chrome';
    else if (userAgent.indexOf('Firefox') > -1) return 'Firefox';
    else if (userAgent.indexOf('FxiOS') > -1) return 'Firefox';
    else if (userAgent.indexOf('Safari') > -1) return 'Safari';
    else if (userAgent.indexOf('MSIE') > -1) return 'Internet Explorer';
    else if (userAgent.indexOf('OPR') > -1 || userAgent.indexOf('Opera')) return 'Opera';
    else return 'Unknown';
  }

  private getUserOS() {
    const userAgent = window.navigator.userAgent;

    if (userAgent.indexOf('like Mac') > -1) return 'iOS';
    else if (userAgent.indexOf('Mac') > -1) return 'Mac';
    else if (userAgent.indexOf('Win') > -1) return 'Windows';
    else if (userAgent.indexOf('Android') > -1) return 'Android';
    else if (userAgent.indexOf('Linux') > -1) return 'Linux';
    else return 'Unknown';
  }
}
